export default class ProductService {

}